import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-552aefd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirm-receipt-modal" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = { class: "content-desc" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))
const _hoisted_7 = { class: "agree" }
const _hoisted_8 = {
  key: 0,
  style: {"color":"red"}
}

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'

export default /*#__PURE__*/_defineComponent({
  emits: ['ok'],
  setup(__props, { expose, emit: emits }) {


const visible = ref(false)
const isAgree = ref(0)
const validateFlag = ref(false)

const receiptContentList = [
  '本公司和THE CKB因信息保护原因无权对您提供的个人名称或法人名称进行审查。',
  '您承诺您提供的抬头内容（个人名称或法人名称）准确无误，并符合相关法律法规的规定。',
  '您承诺更改抬头后的领收书和入金领收书不会用于任何虚假计账、逃税或其他违法行为。',
  '因由您自行更改抬头的入金领收书和领收书导致的任何法律、税务或其他相关问题，均由您自行承担全部贵任。本公司对由您自行更改抬头的入金领收书和领收书引发的任何直接或间接损失概不负责。',
  '因由您自行更改抬头的入金领收书和领收书导致本公司受到任何形式的税务检查、法律追诉、罚款或其他损失，您将承担所有赔偿责任（包括直接损失和预期利益损失）。',
  '请在继续操作前，勾选以下选项以确认您已阅读并同意上述免责声明'
]

const cancel = () => {
  visible.value = false
}
const ok = () => {
  if (isAgree.value === 0) {
    validateFlag.value = true
    return
  }
  emits('ok', isAgree.value === 1)
  visible.value = false
}

const open = () => {
  visible.value = true
}

const handleAgree = () => {
  isAgree.value = isAgree.value === 0 ? 1 : 0
}

expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CommonDialog, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      "show-close": false,
      width: 640,
      className: "confirm-receipt-modal-wrap",
      onOk: ok,
      onCancel: cancel,
      title: _unref(t)('免责声明标题'),
      footer: true,
      okText: _unref(t)('同意1'),
      hideCancelBtn: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('THECKB系统默认入金领收书和领收书上的抬头为您的账户名称，前述文件仅证明与该账户相关的入金和订单情况。如您有正当理由需要将抬头修改为个人名称或法人名称，请您自行修改。修改之前，请您仔细阅读并确认以下内容：')), 1),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(receiptContentList, (item, index) => {
              return _createElementVNode("div", { key: index }, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)(item)), 1)
              ])
            }), 64))
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_checkbox, {
                modelValue: isAgree.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAgree).value = $event)),
                "true-label": 1,
                "false-label": 0
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", {
              style: {"margin-left":"4px"},
              onClick: handleAgree
            }, _toDisplayString(_unref(t)('我已阅读并同意上述免责声明的内容，并确认由我自行承担更改领收书抬头所引发的所有法律和财务责任。')), 1)
          ]),
          (isAgree.value === 0 && validateFlag.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)('必填')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "title", "okText"])
  ]))
}
}

})